module.exports = __webpack_public_path__ + "static/media/3.d7aa3ac0.jpg";